/**
 * @generated SignedSource<<db35550ec05523c55e74e487d34e3e4c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeroCarouselThumb_muxVideo$data = {
  readonly thumbThumbnail: string | null;
  readonly " $fragmentType": "HeroCarouselThumb_muxVideo";
};
export type HeroCarouselThumb_muxVideo$key = {
  readonly " $data"?: HeroCarouselThumb_muxVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselThumb_muxVideo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroCarouselThumb_muxVideo",
  "selections": [
    {
      "alias": "thumbThumbnail",
      "args": [
        {
          "kind": "Literal",
          "name": "height",
          "value": 150
        },
        {
          "kind": "Literal",
          "name": "width",
          "value": 200
        }
      ],
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": "thumbnail(height:150,width:200)"
    }
  ],
  "type": "VideoV2",
  "abstractKey": null
};

(node as any).hash = "c71020c5ee0bfa9923b5e1c8efbadc79";

export default node;
